
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface CreatorCertificateInfoProps {
  formData: any;
  onTemplateChange: (value: string) => void;
  templates?: any[];
}

export function CreatorCertificateInfo({
  formData,
  onTemplateChange,
  templates,
}: CreatorCertificateInfoProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="certificate_template">Certificate Template</Label>
      <Select
        value={formData.certificate_template?.toString() || "none"}
        onValueChange={onTemplateChange}
      >
        <SelectTrigger id="certificate_template" className="w-full">
          <SelectValue placeholder="Select a certificate template" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">None (Use default)</SelectItem>
          {templates?.map((template) => (
            <SelectItem key={template.template_id} value={template.template_id.toString()}>
              {template.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
